import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Navbar from '../Navbar/Navbar';
import { useMediaQuery } from '@mui/material';
import * as XLSX from 'xlsx'; 

const ProductoNegado = () => {
  const [proNegado, setProNegado] = useState([]);
  const isMobile = useMediaQuery('(max-width:600px)');
  const rowsWithId = proNegado.map((row, index) => ({
    id: index + 1, 
    ...row
  }));



  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const response = await fetch('https://bibliotecadlago.com/php/lista_productoNegado.php');
        const data = await response.json();
        if (data.success) {
          setProNegado(data.data);
        } else {
          console.error('Error al obtener pedidos');
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };

    fetchPedidos();
    const intervalo = setInterval(() => {
      fetchPedidos();
    }, 600000); // 10 minutos

    return () => clearInterval(intervalo);
  }, []);

  const columnas = [
    { field: 'MSPN', headerName: 'MSPN', width: isMobile ? 70 : 80 },
    { field: 'descripcion', headerName: 'Descripcion', width: isMobile ? 250 : 300 },
    { field: 'estatus', headerName: 'Estatus', width: isMobile ? 70 : 80 },
    { field: 'marca', headerName: 'Marca', width: 120 },
    { field: 'Cantidad', headerName: 'Cantidad', width: isMobile ? 70 : 80 },
    { field: 'Nombre', headerName: 'Nombre', width: 300 },
    { field: 'fecha', headerName: 'Fecha', width: 300 },
  ];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(proNegado);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ProductoNegado');

    XLSX.writeFile(workbook, 'Producto_Negado.xlsx');
  };

  return (
    <>
      <Navbar />
      <Box p={4}>
        <Typography variant="h4" gutterBottom sx={{ color: '#cf1316', fontWeight: 'bold' }}>
          Producto Negado
        </Typography>

        <Button variant="contained" color="primary" onClick={exportToExcel} sx={{ mb: 2 }}>
          Descargar Excel
        </Button>

        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={rowsWithId}
            columns={columnas}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </Box>
      </Box>
    </>
  );
};

export default ProductoNegado;
